import { getStatusTone } from "@/utils/statusTheme";
import { formatStatusLabel } from "@/utils/textFormat";

/**
 * Power BI-style semantic status badge.
 * Usage: <StatusBadge status={value} type="case|health|payment|invoice|document|submission|renewal|lead|quotation|user|priority|generic" />
 * Backwards-compatible drop-in for the legacy <StatusPill value=… />.
 */
export default function StatusBadge({ status, value, type = "generic", showDot = true, className = "", title, "data-testid": dt }) {
  const raw = status ?? value;
  if (raw == null || raw === "") return null;
  const tone = getStatusTone(raw, type);
  const label = formatStatusLabel(raw);
  return (
    <span
      title={title || label}
      data-testid={dt || `status-badge-${String(raw).toLowerCase()}`}
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md border text-[11px] font-semibold tracking-wide whitespace-nowrap ${tone.bg} ${tone.text} ${tone.border} ${className}`}
    >
      {showDot ? <span className={`w-1.5 h-1.5 rounded-full ${tone.dot}`} /> : null}
      {label}
    </span>
  );
}
